import React, { useState } from 'react';
import styled from 'styled-components';
import HeaderOne from '../../components/parts/HeaderOne';
import UserLayout from '../../components/layouts/UserLayout';
import CreateDraftShopForm from '../../components/combinations/CreateDraftShopForm';
import RadioButton from "../../components/parts/RadioButton";
import EditDraftShopForm from "../../components/combinations/EditDraftShopForm";
import UserHead from "../../config/UserHead";

const CreateShopStyle = styled.div`
  background: white;
  border-radius: 25px;
  text-align: center;
  padding: 20px 30px;
  margin: 30px;

  @media (max-width: 767px) {
    padding: 20px 0;
    margin: 30px 10px;
  }
`;

const HeaderOneStyle = styled(HeaderOne)`
  margin-bottom: 20px;
`;

const RadioButtonGroupStyle = styled.div`
  background: none;
  text-align: center;
  max-width: 600px;
  margin: 0 auto 0 auto;

  @media (max-width: 767px) {
    padding: 0 10px;
  }
`;

const RequestDraftShop: React.FC = (() => {
  const [checkedValue, setCheckedValue] = useState<string>('edit');

  return (
    <UserLayout>
      <UserHead title='店舗申請' />
      <CreateShopStyle>
        <HeaderOneStyle>店舗申請</HeaderOneStyle>
        <RadioButtonGroupStyle>
          <RadioButton selection={[
            { label: '新規店舗の申請', value: 'new' },
            { label: '既存店舗の編集申請', value: 'edit' }
          ]} checkedValue={checkedValue} setCheckedValueAction={setCheckedValue} />
        </RadioButtonGroupStyle>
        { checkedValue === 'new' && <CreateDraftShopForm /> }
        { checkedValue === 'edit' && <EditDraftShopForm /> }
      </CreateShopStyle>
    </UserLayout>
  );
});
export default RequestDraftShop;
